/**
 * @generated SignedSource<<c0f359459b1d7784470bed781ec41ea9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgendaMemberNoteStatus = "HIGH" | "MEDIUM" | "STANDARD";
export type DurationBasedAgendaQuery$variables = {
  courseBucketIds?: ReadonlyArray<string> | null | undefined;
  date: string;
  endTime?: string | null | undefined;
  facilityId: string;
  groupSize?: number | null | undefined;
  isMember: boolean;
  maxDuration: number;
  memberId: string;
  minDuration: number;
  minGroupSize: number;
  startTime?: string | null | undefined;
};
export type DurationBasedAgendaQuery$data = {
  readonly node: {
    readonly agendas?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly memberNote: {
            readonly body: string;
            readonly header: string;
            readonly status: AgendaMemberNoteStatus;
          } | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"TimeListFragment_agenda">;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"TimeListFragment_facility">;
  } | null | undefined;
  readonly session: {
    readonly " $fragmentSpreads": FragmentRefs<"TimeListFragment_session">;
  } | null | undefined;
};
export type DurationBasedAgendaQuery = {
  response: DurationBasedAgendaQuery$data;
  variables: DurationBasedAgendaQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "courseBucketIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endTime"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupSize"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMember"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxDuration"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minDuration"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minGroupSize"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTime"
},
v11 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "facilityId"
  }
],
v12 = [
  {
    "kind": "Variable",
    "name": "dateGte",
    "variableName": "date"
  },
  {
    "kind": "Variable",
    "name": "dateLte",
    "variableName": "date"
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "header",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v18 = [
  (v17/*: any*/),
  (v13/*: any*/)
],
v19 = [
  (v13/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v23 = [
  (v13/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Course",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v23/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseConnection",
  "kind": "LinkedField",
  "name": "courses",
  "plural": false,
  "selections": [
    (v24/*: any*/)
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singular",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plural",
  "storageKey": null
},
v29 = [
  {
    "kind": "Literal",
    "name": "bookingType",
    "value": "STANDARD"
  }
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v31 = [
  {
    "alias": "minPrice",
    "args": [
      {
        "kind": "Variable",
        "name": "duration",
        "variableName": "minDuration"
      },
      {
        "kind": "Variable",
        "name": "playerCount",
        "variableName": "minGroupSize"
      }
    ],
    "kind": "ScalarField",
    "name": "totalDurationBookingPrice",
    "storageKey": null
  },
  {
    "alias": "maxPrice",
    "args": [
      {
        "kind": "Variable",
        "name": "duration",
        "variableName": "maxDuration"
      }
    ],
    "kind": "ScalarField",
    "name": "totalDurationBookingPrice",
    "storageKey": null
  }
],
v32 = {
  "kind": "Literal",
  "name": "memberVisibility",
  "value": [
    "RESTRICTION_ONLY",
    "SLOTS_AND_RESTRICTION"
  ]
},
v33 = {
  "kind": "Literal",
  "name": "type",
  "value": [
    "RESTRICTION"
  ]
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberMessage",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibilityColor",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberVisibility",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allDay",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAt",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v42 = [
  (v22/*: any*/),
  (v13/*: any*/)
],
v43 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v45 = [
  (v43/*: any*/)
],
v46 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DurationBasedAgendaQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TimeListFragment_session"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TimeListFragment_facility"
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "AgendaConnection",
                "kind": "LinkedField",
                "name": "agendas",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agenda",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AgendaMemberNote",
                            "kind": "LinkedField",
                            "name": "memberNote",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "TimeListFragment_agenda"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Facility",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v10/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v5/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "DurationBasedAgendaQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "effectiveClientClass",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v19/*: any*/),
                "type": "MemberProfile",
                "abstractKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v19/*: any*/),
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v19/*: any*/),
                    "type": "Customer",
                    "abstractKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "visibility",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "membershipType",
                    "plural": false,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": null
              },
              (v21/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Club",
                "kind": "LinkedField",
                "name": "club",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "supportsPublic",
                    "storageKey": null
                  },
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CourseBucketConnection",
                "kind": "LinkedField",
                "name": "courseBuckets",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CourseBucketEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CourseBucket",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Course",
                            "kind": "LinkedField",
                            "name": "courses",
                            "plural": true,
                            "selections": (v19/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "AgendaConnection",
                "kind": "LinkedField",
                "name": "agendas",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agenda",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AgendaMemberNote",
                            "kind": "LinkedField",
                            "name": "memberNote",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Facility",
                            "kind": "LinkedField",
                            "name": "facility",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FacilityCopyOverrides",
                                "kind": "LinkedField",
                                "name": "copyOverrides",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "NounOverride",
                                    "kind": "LinkedField",
                                    "name": "course",
                                    "plural": false,
                                    "selections": [
                                      (v27/*: any*/),
                                      (v28/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "durations",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v29/*: any*/),
                                "concreteType": "GroupSize",
                                "kind": "LinkedField",
                                "name": "minMaxGroupSize",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "min",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "max",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "minMaxGroupSize(bookingType:\"STANDARD\")"
                              },
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "courseBucketIds",
                                "variableName": "courseBucketIds"
                              },
                              {
                                "kind": "Variable",
                                "name": "maxDuration",
                                "variableName": "maxDuration"
                              },
                              {
                                "kind": "Variable",
                                "name": "minDuration",
                                "variableName": "minDuration"
                              },
                              {
                                "kind": "Variable",
                                "name": "playerCount",
                                "variableName": "groupSize"
                              },
                              {
                                "kind": "Variable",
                                "name": "timeGte",
                                "variableName": "startTime"
                              },
                              {
                                "kind": "Variable",
                                "name": "timeLte",
                                "variableName": "endTime"
                              }
                            ],
                            "concreteType": "AgendaTime",
                            "kind": "LinkedField",
                            "name": "availableTimes",
                            "plural": true,
                            "selections": [
                              (v30/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dateTime",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v29/*: any*/),
                                "kind": "ScalarField",
                                "name": "capacity",
                                "storageKey": "capacity(bookingType:\"STANDARD\")"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CourseBucket",
                                "kind": "LinkedField",
                                "name": "courseBucket",
                                "plural": false,
                                "selections": (v23/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "seriesLength",
                                "storageKey": null
                              },
                              {
                                "condition": "isMember",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "alias": "bookingRates",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "ratePeriodType",
                                        "value": "BOOKING"
                                      }
                                    ],
                                    "concreteType": "AgendaTimeRate",
                                    "kind": "LinkedField",
                                    "name": "rates",
                                    "plural": true,
                                    "selections": (v31/*: any*/),
                                    "storageKey": "rates(ratePeriodType:\"BOOKING\")"
                                  },
                                  {
                                    "alias": "playerRates",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "ratePeriodType",
                                        "value": "PLAYER"
                                      }
                                    ],
                                    "concreteType": "AgendaTimeRate",
                                    "kind": "LinkedField",
                                    "name": "rates",
                                    "plural": true,
                                    "selections": (v31/*: any*/),
                                    "storageKey": "rates(ratePeriodType:\"PLAYER\")"
                                  }
                                ]
                              },
                              {
                                "condition": "isMember",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SlotPricingPreview",
                                    "kind": "LinkedField",
                                    "name": "pricingPreview",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mode",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "amount",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ]
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "blockingRestrictions",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "bookingType",
                                "value": [
                                  "STANDARD"
                                ]
                              },
                              {
                                "kind": "Literal",
                                "name": "isBlocking",
                                "value": true
                              },
                              (v32/*: any*/),
                              (v33/*: any*/)
                            ],
                            "concreteType": "AgendaBookingRulesConnection",
                            "kind": "LinkedField",
                            "name": "bookingRules",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgendaBookingRulesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "liftAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v13/*: any*/),
                                      (v22/*: any*/),
                                      (v34/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v35/*: any*/),
                                          (v36/*: any*/),
                                          (v37/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BookingRuleWindow",
                                            "kind": "LinkedField",
                                            "name": "liftBookingRuleWindow",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "daysAhead",
                                                "storageKey": null
                                              },
                                              (v30/*: any*/),
                                              (v13/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BookingRuleSlotCriteria",
                                            "kind": "LinkedField",
                                            "name": "slotCriteria",
                                            "plural": false,
                                            "selections": [
                                              (v38/*: any*/),
                                              (v39/*: any*/),
                                              (v40/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CourseConnection",
                                                "kind": "LinkedField",
                                                "name": "courses",
                                                "plural": false,
                                                "selections": [
                                                  (v41/*: any*/),
                                                  (v24/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v13/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "BookingRestrictionRule",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "bookingRules(bookingType:[\"STANDARD\"],isBlocking:true,memberVisibility:[\"RESTRICTION_ONLY\",\"SLOTS_AND_RESTRICTION\"],type:[\"RESTRICTION\"])"
                          },
                          {
                            "alias": "infoRestrictions",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "isBlocking",
                                "value": false
                              },
                              (v32/*: any*/),
                              (v33/*: any*/)
                            ],
                            "concreteType": "AgendaBookingRulesConnection",
                            "kind": "LinkedField",
                            "name": "bookingRules",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgendaBookingRulesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v13/*: any*/),
                                      (v22/*: any*/),
                                      (v34/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v35/*: any*/),
                                          (v36/*: any*/),
                                          (v37/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BookingRuleSlotCriteria",
                                            "kind": "LinkedField",
                                            "name": "slotCriteria",
                                            "plural": false,
                                            "selections": [
                                              (v38/*: any*/),
                                              (v39/*: any*/),
                                              (v40/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CourseConnection",
                                                "kind": "LinkedField",
                                                "name": "courses",
                                                "plural": false,
                                                "selections": [
                                                  (v41/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CourseEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Course",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": (v42/*: any*/),
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              (v13/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "BookingRestrictionRule",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "bookingRules(isBlocking:false,memberVisibility:[\"RESTRICTION_ONLY\",\"SLOTS_AND_RESTRICTION\"],type:[\"RESTRICTION\"])"
                          },
                          {
                            "alias": null,
                            "args": [
                              (v43/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "isVisibleToMembers",
                                "value": true
                              }
                            ],
                            "concreteType": "TimeSlotBlockConnection",
                            "kind": "LinkedField",
                            "name": "blocks",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TimeSlotBlockEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TimeSlotBlock",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v39/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "durationMins",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BlockSeries",
                                        "kind": "LinkedField",
                                        "name": "blockSeries",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v44/*: any*/),
                                          (v13/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v25/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "blocks(first:1000,isVisibleToMembers:true)"
                          },
                          {
                            "alias": null,
                            "args": (v45/*: any*/),
                            "concreteType": "EventConnection",
                            "kind": "LinkedField",
                            "name": "events",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventSeries",
                                        "kind": "LinkedField",
                                        "name": "eventSeries",
                                        "plural": false,
                                        "selections": (v42/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": (v45/*: any*/),
                                        "concreteType": "EventSessionConnection",
                                        "kind": "LinkedField",
                                        "name": "eventSessions",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EventSessionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "EventSession",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v39/*: any*/),
                                                  (v40/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Agenda",
                                                    "kind": "LinkedField",
                                                    "name": "agenda",
                                                    "plural": false,
                                                    "selections": [
                                                      (v26/*: any*/),
                                                      (v13/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TimeSlotConnection",
                                                    "kind": "LinkedField",
                                                    "name": "timeSlots",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "lastDateTime",
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v13/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "bookingsPublishedAt",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "displayTime",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "event",
                                                    "plural": false,
                                                    "selections": [
                                                      (v13/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "EventTagConnection",
                                                        "kind": "LinkedField",
                                                        "name": "tags",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventTagEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "EventTag",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": (v42/*: any*/),
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": (v46/*: any*/),
                                                        "concreteType": "EventSignUpWindow",
                                                        "kind": "LinkedField",
                                                        "name": "clientEligibleSignUpWindows",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "opensAt",
                                                            "storageKey": null
                                                          },
                                                          (v13/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": (v46/*: any*/),
                                                        "kind": "ScalarField",
                                                        "name": "accessStatusForClient",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": (v46/*: any*/),
                                                        "kind": "ScalarField",
                                                        "name": "signUpStatusForClient",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "spotsAvailable",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "EventSeries",
                                                        "kind": "LinkedField",
                                                        "name": "eventSeries",
                                                        "plural": false,
                                                        "selections": [
                                                          (v44/*: any*/),
                                                          (v22/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Facility",
                                                            "kind": "LinkedField",
                                                            "name": "facility",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "FacilityCopyOverrides",
                                                                "kind": "LinkedField",
                                                                "name": "copyOverrides",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "NounOverride",
                                                                    "kind": "LinkedField",
                                                                    "name": "course",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v28/*: any*/),
                                                                      (v27/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Department",
                                                                "kind": "LinkedField",
                                                                "name": "department",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "type",
                                                                    "storageKey": null
                                                                  },
                                                                  (v22/*: any*/),
                                                                  (v13/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v13/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Image",
                                                            "kind": "LinkedField",
                                                            "name": "image",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": "publicId",
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "renderingKey",
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          (v13/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CourseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "courses",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "CourseEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Course",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v22/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "CourseBucket",
                                                                "kind": "LinkedField",
                                                                "name": "courseBucket",
                                                                "plural": false,
                                                                "selections": (v42/*: any*/),
                                                                "storageKey": null
                                                              },
                                                              (v13/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "eventSessions(first:1000)"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "events(first:1000)"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Facility",
            "abstractKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "296e94732c8cdcc39369e8fbee6bbd69",
    "id": null,
    "metadata": {},
    "name": "DurationBasedAgendaQuery",
    "operationKind": "query",
    "text": "query DurationBasedAgendaQuery(\n  $facilityId: ID!\n  $date: Date!\n  $courseBucketIds: [ID!]\n  $groupSize: Int\n  $startTime: Time\n  $endTime: Time\n  $maxDuration: Int!\n  $minDuration: Int!\n  $isMember: Boolean!\n  $minGroupSize: Int!\n  $memberId: ID!\n) {\n  session {\n    ...TimeListFragment_session\n  }\n  node(id: $facilityId) {\n    __typename\n    ... on Facility {\n      ...TimeListFragment_facility\n      agendas(dateGte: $date, dateLte: $date) {\n        edges {\n          node {\n            id\n            memberNote {\n              body\n              header\n              status\n              id\n            }\n            ...TimeListFragment_agenda\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment TimeListEventsCard_EventSession on EventSession {\n  id\n  bookingsPublishedAt\n  displayTime\n  startAt\n  endAt\n  agenda {\n    date\n    id\n  }\n  event {\n    id\n    tags {\n      edges {\n        node {\n          name\n          id\n        }\n      }\n    }\n    clientEligibleSignUpWindows(clientId: $memberId) {\n      opensAt\n      id\n    }\n    accessStatusForClient(clientId: $memberId)\n    signUpStatusForClient(clientId: $memberId)\n    spotsAvailable\n    eventSeries {\n      color\n      name\n      facility {\n        copyOverrides {\n          course {\n            plural\n          }\n        }\n        department {\n          type\n          name\n          id\n        }\n        id\n      }\n      image {\n        publicId: renderingKey\n      }\n      id\n    }\n  }\n  ...useEventLocationLabel_Event\n}\n\nfragment TimeListFragment_agenda on Agenda {\n  id\n  date\n  ...useTimeListComponentsAgendaFragment_agenda\n}\n\nfragment TimeListFragment_facility on Facility {\n  club {\n    slug\n    supportsPublic\n    id\n  }\n  courses {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  courseBuckets {\n    edges {\n      node {\n        id\n        name\n        courses {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment TimeListFragment_session on Session {\n  effectiveClientClass\n  user {\n    __typename\n    id\n  }\n  currentClientProfile {\n    __typename\n    ... on MemberProfile {\n      id\n    }\n    member {\n      __typename\n      ... on Member {\n        id\n      }\n      ... on Customer {\n        id\n      }\n      club {\n        id\n        slug\n        visibility\n      }\n      membershipType {\n        __typename\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useEventLocationLabel_Event on EventSession {\n  courses {\n    edges {\n      node {\n        name\n        courseBucket {\n          name\n          id\n        }\n        id\n      }\n    }\n  }\n  event {\n    eventSeries {\n      facility {\n        ...useFacilityCourseNoun_facility\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useFacilityCourseNoun_facility on Facility {\n  copyOverrides {\n    course {\n      singular\n      plural\n    }\n  }\n}\n\nfragment useTimeListComponentsAgendaFragment_agenda on Agenda {\n  id\n  date\n  facility {\n    ...useFacilityCourseNoun_facility\n    durations\n    minMaxGroupSize(bookingType: STANDARD) {\n      min\n      max\n    }\n    id\n  }\n  availableTimes(minDuration: $minDuration, maxDuration: $maxDuration, playerCount: $groupSize, courseBucketIds: $courseBucketIds, timeGte: $startTime, timeLte: $endTime) {\n    time\n    dateTime\n    capacity(bookingType: STANDARD)\n    courseBucket {\n      id\n      name\n    }\n    seriesLength\n    bookingRates: rates(ratePeriodType: BOOKING) @include(if: $isMember) {\n      minPrice: totalDurationBookingPrice(duration: $minDuration, playerCount: $minGroupSize)\n      maxPrice: totalDurationBookingPrice(duration: $maxDuration)\n    }\n    playerRates: rates(ratePeriodType: PLAYER) @include(if: $isMember) {\n      minPrice: totalDurationBookingPrice(duration: $minDuration, playerCount: $minGroupSize)\n      maxPrice: totalDurationBookingPrice(duration: $maxDuration)\n    }\n    pricingPreview @skip(if: $isMember) {\n      mode\n      amount\n    }\n  }\n  blockingRestrictions: bookingRules(type: [RESTRICTION], bookingType: [STANDARD], isBlocking: true, memberVisibility: [RESTRICTION_ONLY, SLOTS_AND_RESTRICTION]) {\n    edges {\n      liftAt\n      node {\n        __typename\n        id\n        name\n        displayName\n        ... on BookingRestrictionRule {\n          memberMessage\n          visibilityColor\n          memberVisibility\n          liftBookingRuleWindow {\n            daysAhead\n            time\n            id\n          }\n          slotCriteria {\n            allDay\n            startAt\n            endAt\n            courses {\n              count\n              edges {\n                node {\n                  id\n                  name\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  infoRestrictions: bookingRules(type: [RESTRICTION], isBlocking: false, memberVisibility: [RESTRICTION_ONLY, SLOTS_AND_RESTRICTION]) {\n    edges {\n      node {\n        __typename\n        id\n        name\n        displayName\n        ... on BookingRestrictionRule {\n          memberMessage\n          visibilityColor\n          memberVisibility\n          slotCriteria {\n            allDay\n            startAt\n            endAt\n            courses {\n              count\n              edges {\n                node {\n                  name\n                  id\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  blocks(first: 1000, isVisibleToMembers: true) {\n    edges {\n      node {\n        id\n        startAt\n        durationMins\n        blockSeries {\n          name\n          color\n          id\n        }\n        courses {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n  events(first: 1000) {\n    edges {\n      node {\n        id\n        eventSeries {\n          name\n          id\n        }\n        eventSessions(first: 1000) {\n          edges {\n            node {\n              startAt\n              endAt\n              agenda {\n                date\n                id\n              }\n              timeSlots {\n                lastDateTime\n              }\n              ...TimeListEventsCard_EventSession\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b7b4d314001c03764ff6fa9b77d47de8";

export default node;
